<script>
    import Dropdown from './Dropdown.vue'
    import request from '@/utils/request'

    export default {
        /*
        |--------------------------------------------------------------------------
        | Component > extends
        |--------------------------------------------------------------------------
        */
        extends: Dropdown, // End of Component > extends

        /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */
        props: {
            textField: {
                type: String,
                default: 'title',
            },
            valueField: {
                type: String,
                default: '_id',
            },
        }, // End of Component > props

        /*
        |--------------------------------------------------------------------------
        | Component > data
        |--------------------------------------------------------------------------
        */
        data() {
            return {
                options: [],
            }
        }, // End of Component > mounted

        /*
        |--------------------------------------------------------------------------
        | Component > watch
        |--------------------------------------------------------------------------
        */
        watch: {
            dataSegmentId(value) {
                if (value) {
                    this.getRecords()
                }
            },
            model(value) {
                if (value) {
                    // let selectedItem = this.options.find(
                    //     (item) => item._id === value
                    // )
                    //
                    // let tempKey=this.field.key.replace('Id','')
                    //
                    // this.$store.commit('updateField', {
                    //     key: tempKey,
                    //     value: selectedItem.title,
                    // })

                }
            },
        }, // End of Component > methods

        /*
        |--------------------------------------------------------------------------
        | Component > mounted
        |--------------------------------------------------------------------------
        */
        created(){
            var some = this.field.key.split('.')
            if (this.field.customerDetails && this.field.customerDetails[some[0]][some[1]]){
                this.model = this.field.customerDetails[some[0]][some[1]]

            }
        },
        async mounted() {
            await this.getRecords()
        }, // End of Component > data

        /*
        |--------------------------------------------------------------------------
        | Component > methods
        |--------------------------------------------------------------------------
        */
        methods: {
            /**
             * get the dropdown values when required
             *
             * @return {void}
             */
            async getRecords() {
                try {
                    // fetch the list of associated configurations
                    if(this.field.isAssociation)
                    {
                        let { data } = await request({
                            url: `/configurations/${this.field.association}`,
                            params: {
                                dataSegmentId: this.dataSegmentId,
                                status: 'active',
                                perPage: 1000,
                                ref: 'dropdown',
                            },
                        })

                        // update the local list of options

                        let fieldOptions = data.data

                        let tempArr= []
                        for(let i=0; i<fieldOptions.length;i++)
                        {
                            let tempObj={}

                            if(fieldOptions[i] && fieldOptions[i].investmentRange)
                            {
                                let value = fieldOptions[i].investmentRange.minimum + " to " + fieldOptions[i].investmentRange.maximum
                                tempObj._id=value
                                tempObj.title=value
                            }
                            tempArr.push(tempObj)
                        }
                        this.options=tempArr
                    }

                } catch (error) {
                    console.log(error)
                }
            }, // End of getRecords() method

        }, // End of Component > watch
    }
</script>
